import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import logoImg from './assets/logo.jpeg';
import heroBg from './assets/background.jpeg';
import reputationImg from './assets/Reputation.jpeg';
import servicesImg from './assets/bestservices.jpeg';
import safetyImg from './assets/safetysecurity.jpeg';
import bigFeatureImg from './assets/products.jpeg';
import groundnutImg from './assets/groundnut.jpeg';
import groundnutOilImg from './assets/groundnutoil.jpeg';
import desichanaImg from './assets/Chana.jpeg';
import groundnetinabout from './assets/grounnetinabout.jpeg';
import fssaiImg from './assets/fssai.jpeg';
import apedaImg from './assets/Apeda.jpeg';
import dgftImg from './assets/ForeignTrade.jpeg';
import contactmail from './assets/contactmail-icon.jpeg';
import contactphone from './assets/contactphone-icon.jpeg';
import contactlocation from './assets/contactlocation-icon.jpeg';
import redpeanuts from './assets/redpeanuts.jpeg';
import customs from './assets/customs.jpeg';
import packaging from './assets/packingandstorage.jpeg';
import logistics from './assets/logistics.jpeg';
import businessservice from './assets/businessservices.jpeg';
import locationIcon from './assets/location-icon.jpeg';
import mailIcon from './assets/mail-icon.jpeg';
import phoneIcon from './assets/phone-icon.jpeg';
import millImg1 from './assets/millImg1.jpeg';
import millImg2 from './assets/millImg2.jpeg';
import millImg3 from './assets/millImg3.jpeg';
import millImg4 from './assets/millImg4.jpeg';
import bananaImg from './assets/banana/banana.jpeg';
import dehydrationBananaImg from './assets/dehydrationPowder/banana.jpeg';
import carrotPowderImg from './assets/dehydrationPowder/carrot.jpeg';
import beetrootPowderImg from './assets/dehydrationPowder/beetroot.jpeg';
import gingerPowderImg from './assets/dehydrationPowder/ginger.jpeg';
import lemonPowderImg from './assets/dehydrationPowder/lemon.jpeg';
import moringaPowderImg from './assets/dehydrationPowder/moringa.jpeg';
import fssaiCertificate from './assets/FSSAI Licence @ HANUMAN GLOBAL.pdf';
import gstCertificate from './assets/certifications/GST CERTIFICATE .pdf';
import iecCertificate from './assets/certifications/IEC CERTIFICTAE.pdf';
import udyamCertificate from './assets/certifications/Print _ Udyam Registration Certificate.pdf';
import { ArrowRight, BadgeCheck, Building2, CheckCircle2, Factory, FileText, Globe2, Leaf, Menu, ShieldCheck, Sparkles, Truck } from 'lucide-react';

const navItems = ['home', 'about', 'products', 'certifications', 'gallery', 'contact'];
const dehydrationPowders = [
  {
    name: 'Moringa Powder',
    image: moringaPowderImg,
    description: 'Nutrient-rich moringa leaves carefully dried and milled into a fine powder for food, wellness, and ingredient applications.'
  },
  {
    name: 'Ginger Powder',
    image: gingerPowderImg,
    description: 'A naturally warming and aromatic ingredient made from selected ginger, dried to preserve its distinctive flavour and quality.'
  },
  {
    name: 'Lemon Powder',
    image: lemonPowderImg,
    description: 'Bright, naturally citrusy lemon powder suitable for beverages, bakery products, seasoning blends, and food manufacturing.'
  },
  {
    name: 'Banana Powder',
    image: dehydrationBananaImg,
    description: 'Gently dried banana powder with a naturally mild sweetness for nutrition products, bakery, and food applications.'
  },
  {
    name: 'Carrot Powder',
    image: carrotPowderImg,
    description: 'Naturally dried carrot powder with a mild earthy sweetness for soups, sauces, bakery products, and food blends.'
  },
  {
    name: 'Beetroot Powder',
    image: beetrootPowderImg,
    description: 'Vibrant beetroot powder prepared from carefully dehydrated beets for natural colour, nutrition, and food applications.'
  }
];

const sectionClasses = 'mx-auto max-w-7xl px-4 sm:px-6 lg:px-8';

const SectionHeading = ({ title, eyebrow }) => (
  <div className="mb-10 text-center md:mb-14">
    {eyebrow && <p className="mb-3 text-sm font-semibold uppercase tracking-[0.35em] text-amber-700">{eyebrow}</p>}
    <h2 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">{title}</h2>
    <div className="mx-auto mt-4 h-1.5 w-24 rounded-full bg-amber-600" />
  </div>
);

const HanumanModern = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [productType, setProductType] = useState('groundnut');
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const companyName = 'HANUMAN GLOBAL EXPORTS AND IMPORTS';

  const navigateTo = (tab) => {
    setActiveTab(tab);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const whyChooseUs = [
    { img: servicesImg, title: 'Best Services', text: 'We provide our import and export services throughout the world with exceptional care and precision.' },
    { img: reputationImg, title: 'Reputation', text: 'With a strong presence in the market and a trusted working ethic, we continue to build long-term partnerships.' },
    { img: safetyImg, title: 'Safety & Security', text: 'We uphold strict measures to ensure every shipment is protected, secure, and compliant.' }
  ];

  const featuredProducts = [
    { img: groundnutImg, title: 'Premium Groundnuts', description: 'High-quality, oil-rich groundnuts sourced from key farming regions.' },
    { img: bananaImg, title: 'Farm-Fresh Bananas', description: 'Carefully sourced bananas selected for freshness, quality, and reliable supply to global markets.' },
    ...dehydrationPowders.map((powder) => ({
      img: powder.image,
      title: powder.name,
      description: powder.description
    }))
  ];

  const certifications = [
    {
      file: fssaiCertificate,
      image: fssaiImg,
      title: 'FSSAI License',
      category: 'Food safety compliance',
      desc: 'Ensuring food safety and hygiene standards for all our agricultural exports.'
    },
    {
      file: iecCertificate,
      image: dgftImg,
      title: 'DGFT Import Export Code (IEC)',
      category: 'International trade',
      desc: 'Recognized by the Directorate General of Foreign Trade with a valid Import Export Code.'
    },
    {
      file: gstCertificate,
      title: 'GST Registration Certificate',
      category: 'Business registration',
      desc: 'Official tax registration supporting transparent and compliant business operations in India.'
    },
    {
      file: udyamCertificate,
      title: 'Udyam Registration',
      category: 'Enterprise registration',
      desc: 'Recognition of Hanuman Global Exports and Imports as a registered Indian enterprise.'
    },
    {
      image: apedaImg,
      title: 'APEDA Member',
      category: 'Agricultural exports',
      desc: 'Registered with the Agricultural and Processed Food Products Export Development Authority.'
    }
  ];

  const renderHome = () => (
    <div className="overflow-hidden bg-[#f8f5ee]">
      <section className="relative isolate overflow-hidden bg-slate-950 text-white">
        <img src={heroBg} alt="Agricultural export background" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/80 to-slate-900/50" />
        <div className={`relative mx-auto flex min-h-[80vh] max-w-7xl items-center px-4 py-24 sm:px-6 lg:px-8 lg:py-32 ${isMobile ? 'text-center' : ''}`}>
          <div className="max-w-3xl">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-medium text-amber-200 backdrop-blur">
              <Sparkles size={16} />
              Trusted agricultural export partner
            </div>
            <h1 className="text-4xl font-semibold leading-tight sm:text-5xl lg:text-6xl">
              Connecting Indian farms to global tables with integrity and care.
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300 sm:text-xl">
              We deliver premium agricultural products with a focus on quality, consistency, and dependable international trade operations.
            </p>
            <div className={`mt-8 flex flex-wrap gap-4 ${isMobile ? 'justify-center' : ''}`}>
              <button onClick={() => navigateTo('products')} className="inline-flex items-center gap-2 rounded-full bg-amber-600 px-6 py-3 font-semibold text-white transition hover:bg-amber-500">
                Explore products <ArrowRight size={18} />
              </button>
              <button onClick={() => navigateTo('contact')} className="rounded-full border border-white/30 bg-white/10 px-6 py-3 font-semibold text-white backdrop-blur transition hover:bg-white/20">
                Contact us
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 sm:py-24">
        <div className={sectionClasses}>
          <SectionHeading title="Why Choose Us" eyebrow="Our edge" />
          <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
            <div className="space-y-6">
              {whyChooseUs.map((item, index) => (
                <div key={item.title} className="flex flex-col gap-4 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:flex-row sm:items-start">
                  <img src={item.img} alt={item.title} className="h-20 w-20 rounded-2xl object-cover" />
                  <div>
                    <div className="mb-2 flex items-center gap-2 text-amber-700">
                      <CheckCircle2 size={18} />
                      <h3 className="text-lg font-semibold text-slate-900">{item.title}</h3>
                    </div>
                    <p className="leading-7 text-slate-600">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-3 shadow-sm">
              <img src={bigFeatureImg} alt="Premium export quality" className="h-[400px] w-full rounded-[1.5rem] object-cover sm:h-[480px]" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-24">
        <div className={sectionClasses}>
          <SectionHeading title="Our Products" eyebrow="From farm to finished ingredient" />
          <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
            {featuredProducts.map((item) => (
              <div key={item.title} className="group overflow-hidden rounded-[2rem] border border-slate-200 bg-[#faf7f1] shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
                <img src={item.img} alt={item.title} className="h-72 w-full object-cover" />
                <div className="p-8">
                  <h3 className="text-2xl font-semibold text-slate-900">{item.title}</h3>
                  <p className="mt-3 leading-7 text-slate-600">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );

  const renderAbout = () => (
    <div className="bg-[#f8f5ee] py-20 sm:py-24">
      <div className={sectionClasses}>
        <SectionHeading title="About Us" eyebrow="Our story" />
        <div className="grid gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:items-start">
          <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-3 shadow-sm">
            <img src={bigFeatureImg} alt="About Hanuman Global" className="h-[360px] w-full rounded-[1.5rem] object-cover sm:h-[450px]" />
          </div>
          <div className="space-y-6 rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm sm:p-10">
            <p className="text-lg leading-8 text-slate-600">
              At <span className="font-semibold text-slate-900">{companyName}</span>, we connect trusted Indian farms with global markets through careful sourcing, systematic processing, and dependable export support. Our work begins directly with farmers and established agricultural networks, helping us maintain control over freshness, quality, and consistency.
            </p>
            <div className="grid gap-4 sm:grid-cols-2">
              <div className="rounded-2xl bg-[#faf7f1] p-5">
                <div className="mb-3 flex items-center gap-2 text-amber-700">
                  <Building2 size={18} />
                  <h3 className="font-semibold text-slate-900">Our Foundation</h3>
                </div>
                <p className="leading-7 text-slate-600">Based in Kadapa, Andhra Pradesh, we build reliable relationships with farmers and local suppliers to support consistent procurement throughout the season.</p>
              </div>
              <div className="rounded-2xl bg-[#faf7f1] p-5">
                <div className="mb-3 flex items-center gap-2 text-amber-700">
                  <Globe2 size={18} />
                  <h3 className="font-semibold text-slate-900">Our Global Outlook</h3>
                </div>
                <p className="leading-7 text-slate-600">We prepare agricultural products for buyers across global markets with clear communication, secure packaging, and dependable supply.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm sm:p-10">
            <h3 className="text-2xl font-semibold text-slate-900">From Farm to Global Markets</h3>
            <p className="mt-4 leading-8 text-slate-600">
              Our procurement and processing approach is built around traceability and transparency. Peanuts move through cleaning, destoning, sorting, grading, quality inspection, and food-grade packaging before reaching customers. Alongside groundnuts, bananas, and other agricultural products, we are developing a focused range of dehydrated powders including moringa, ginger, lemon, banana, carrot, and beetroot for food and wellness applications.
            </p>
          </div>
          <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-3 shadow-sm">
            <img src={groundnetinabout} alt="Groundnut processing" className="h-[320px] w-full rounded-[1.5rem] object-cover sm:h-[380px]" />
          </div>
        </div>
      </div>
    </div>
  );

  const renderProducts = () => (
    <div className="bg-[#f8f5ee] py-20 sm:py-24">
      <div className={sectionClasses}>
        <SectionHeading title="Our Product Range" eyebrow="Quality from source" />
        <div className="mb-8 flex flex-wrap gap-3 rounded-full border border-slate-200 bg-white p-2 shadow-sm">
          <button onClick={() => setProductType('groundnut')} className={`rounded-full px-5 py-2.5 text-sm font-semibold transition ${productType === 'groundnut' ? 'bg-amber-600 text-white' : 'text-slate-700 hover:bg-slate-100'}`}>
            Groundnut
          </button>
          <button onClick={() => setProductType('banana')} className={`rounded-full px-5 py-2.5 text-sm font-semibold transition ${productType === 'banana' ? 'bg-amber-600 text-white' : 'text-slate-700 hover:bg-slate-100'}`}>
            Banana
          </button>
          <button onClick={() => setProductType('dehydration')} className={`rounded-full px-5 py-2.5 text-sm font-semibold transition ${productType === 'dehydration' ? 'bg-amber-600 text-white' : 'text-slate-700 hover:bg-slate-100'}`}>
            Dehydration Powders
          </button>
          <button onClick={() => setProductType('cereals')} className={`rounded-full px-5 py-2.5 text-sm font-semibold transition ${productType === 'cereals' ? 'bg-amber-600 text-white' : 'text-slate-700 hover:bg-slate-100'}`}>
            Cereals &amp; Pulses
          </button>
          <button onClick={() => setProductType('oils')} className={`rounded-full px-5 py-2.5 text-sm font-semibold transition ${productType === 'oils' ? 'bg-amber-600 text-white' : 'text-slate-700 hover:bg-slate-100'}`}>
            Edible Oils
          </button>
        </div>

        {productType === 'groundnut' ? (
        <div className="space-y-10">
            {[
              {
                img: groundnutImg,
                title: 'Bold Groundnut Kernels',
                desc: 'Large, oval-shaped, and rich in oil content, preferred for roasted snacks, bakery, and oil extraction.',
                uses: ['Oil extraction', 'Roasting and snacking', 'Bakery applications'],
                specs: { Size: 'Large (50/60, 60/70)', Skin: 'Light red', Shape: 'Oval', 'Oil content': '48–50%' }
              },
              {
                img: groundnetinabout,
                title: 'Java Groundnut Kernels',
                desc: 'Smaller and rounder kernels preferred for peanut butter, ready-to-eat mixes, and snack food industries.',
                uses: ['Peanut butter', 'Boiled peanut snacks', 'Ready mixes'],
                specs: { Size: 'Medium-small', Skin: 'Pinkish', Shape: 'Round', 'Oil content': '42–48%' }
              },
              {
                img: redpeanuts,
                title: 'Redskin Groundnut Kernels',
                desc: 'Known for their rich flavour and high fibre content, ideal for natural health-focused products.',
                uses: ['Health snacks', 'Trail mixes', 'Natural spreads'],
                specs: { Skin: 'Deep red', Size: 'Medium to small', Flavour: 'Intense', 'Oil content': '47–50%' }
              }
            ].map((item) => (
              <div key={item.title} className="grid gap-8 rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm lg:grid-cols-[0.95fr_1.05fr] lg:p-8">
                <img src={item.img} alt={item.title} className="h-[280px] w-full rounded-[1.5rem] object-cover sm:h-[320px]" />
                <div>
                  <h3 className="text-2xl font-semibold text-slate-900">{item.title}</h3>
                  <p className="mt-3 leading-8 text-slate-600">{item.desc}</p>
                  <ul className="mt-5 space-y-2 text-slate-600">
                    {item.uses.map((use) => <li key={use} className="flex items-center gap-2"><Leaf size={16} className="text-amber-700" />{use}</li>)}
                  </ul>
                  <div className="mt-6 rounded-2xl border border-slate-200 bg-[#faf7f1] p-5">
                    <h4 className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Key characteristics</h4>
                    <div className="mt-4 grid gap-3 sm:grid-cols-2">
                      {Object.entries(item.specs).map(([key, value]) => (
                        <div key={key} className="rounded-xl bg-white p-3 text-sm text-slate-600">
                          <span className="font-semibold text-slate-900">{key}:</span> {value}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
        ) : productType === 'banana' ? (
          <div className="grid gap-8 rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm lg:grid-cols-[0.95fr_1.05fr] lg:p-8">
            <img src={bananaImg} alt="Farm-fresh bananas" className="h-[280px] w-full rounded-[1.5rem] object-cover sm:h-[420px]" />
            <div>
              <h3 className="text-2xl font-semibold text-slate-900">Farm-Fresh Bananas</h3>
              <p className="mt-3 leading-8 text-slate-600">Carefully sourced from trusted farming networks, our bananas are selected for freshness, quality, and reliable supply to global markets.</p>
              <ul className="mt-5 space-y-2 text-slate-600">
                {['Fresh farm sourcing', 'Careful quality selection', 'Reliable export supply'].map((use) => <li key={use} className="flex items-center gap-2"><Leaf size={16} className="text-amber-700" />{use}</li>)}
              </ul>
              <div className="mt-6 rounded-2xl border border-slate-200 bg-[#faf7f1] p-5">
                <h4 className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Product focus</h4>
                <p className="mt-3 text-sm leading-7 text-slate-600">Freshness, consistency, and careful handling from farm to destination.</p>
              </div>
            </div>
          </div>
        ) : productType === 'dehydration' ? (
          <div>
            <div className="mb-10 max-w-3xl">
              <h3 className="text-2xl font-semibold text-slate-900 sm:text-3xl">Dehydration Powders</h3>
              <p className="mt-3 leading-8 text-slate-600">Our carefully dehydrated ingredient range is prepared to retain natural character, consistent quality, and convenient usability across food and wellness applications.</p>
            </div>
            <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
              {dehydrationPowders.map((powder) => (
                <article key={powder.name} className="overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-md">
                  <img src={powder.image} alt={powder.name} className="h-56 w-full object-cover" />
                  <div className="p-6">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-700">Dehydrated ingredient</p>
                    <h3 className="mt-2 text-xl font-semibold text-slate-900">{powder.name}</h3>
                    <p className="mt-3 leading-7 text-slate-600">{powder.description}</p>
                    <div className="mt-5 flex items-center gap-2 text-sm font-semibold text-slate-900"><CheckCircle2 size={16} className="text-amber-700" /> Quality-focused processing</div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ) : productType === 'cereals' ? (
          <div className="grid gap-8 rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm lg:grid-cols-[0.95fr_1.05fr] lg:p-8">
            <img src={desichanaImg} alt="Desi Chana" className="h-[280px] w-full rounded-[1.5rem] object-cover sm:h-[420px]" />
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-700">Cereals &amp; pulses</p>
              <h3 className="mt-2 text-2xl font-semibold text-slate-900">Desi Chana</h3>
              <p className="mt-3 leading-8 text-slate-600">Carefully sourced Indian chickpeas selected for consistent quality and suitable for everyday cooking, food processing, and export markets.</p>
              <ul className="mt-5 space-y-2 text-slate-600">
                {['Direct agricultural sourcing', 'Careful lot selection', 'Reliable export supply'].map((use) => <li key={use} className="flex items-center gap-2"><Leaf size={16} className="text-amber-700" />{use}</li>)}
              </ul>
              <div className="mt-6 rounded-2xl border border-slate-200 bg-[#faf7f1] p-5">
                <h4 className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Product focus</h4>
                <p className="mt-3 text-sm leading-7 text-slate-600">Natural flavour, dependable quality, and careful preparation for domestic and international buyers.</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="grid gap-8 rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm lg:grid-cols-[0.95fr_1.05fr] lg:p-8">
            <img src={groundnutOilImg} alt="Groundnut oil" className="h-[280px] w-full rounded-[1.5rem] object-cover sm:h-[420px]" />
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-700">Edible oils</p>
              <h3 className="mt-2 text-2xl font-semibold text-slate-900">Cold-Pressed Groundnut Oil</h3>
              <p className="mt-3 leading-8 text-slate-600">Cold-pressed groundnut oil made from carefully selected peanuts, retaining its natural flavour and character for cooking, food manufacturing, and dependable supply to global markets.</p>
              <ul className="mt-5 space-y-2 text-slate-600">
                {['Selected groundnut sourcing', 'Quality-focused processing', 'Suitable for food applications'].map((use) => <li key={use} className="flex items-center gap-2"><Leaf size={16} className="text-amber-700" />{use}</li>)}
              </ul>
              <div className="mt-6 rounded-2xl border border-slate-200 bg-[#faf7f1] p-5">
                <h4 className="text-sm font-semibold uppercase tracking-[0.25em] text-amber-700">Product focus</h4>
                <p className="mt-3 text-sm leading-7 text-slate-600">Traditional cold-press extraction, consistent quality, and careful handling for domestic and international buyers.</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const renderServices = () => (
    <div className="bg-[#f8f5ee] py-20 sm:py-24">
      <div className={sectionClasses}>
        <SectionHeading title="Our Professional Services" eyebrow="End-to-end support" />
        <div className="space-y-10">
          {[{
            title: 'B2B Services',
            image: businessservice,
            text: 'We build strong business connections with traders and manufacturers to source quality products and deliver consistent supply for international markets.',
            bulletPoints: ['Reliable sourcing partner', 'Quality-driven partnerships', 'Long-term supply arrangements']
          }, {
            title: 'Customs House Agent Services',
            image: customs,
            text: 'A professional link between our firm and the customs department, ensuring smooth clearance for export and import activities.',
            bulletPoints: ['Documentation support', 'Efficient port coordination', 'Compliance guidance']
          }, {
            title: 'Packing and Storage',
            image: packaging,
            text: 'Proper packing and storage preserve quality, prevent contamination, and reduce losses throughout the supply chain.',
            bulletPoints: ['Food-grade materials', 'Moisture control', 'Strict inspection records']
          }, {
            title: 'Logistics and Supply Chain',
            image: logistics,
            text: 'We provide end-to-end logistics solutions to move agricultural products from Indian farms to global destinations efficiently.',
            bulletPoints: ['Multimodal transport', 'Real-time tracking', 'Risk management']
          }].map((service, index) => (
            <div key={service.title} className={`grid gap-8 rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm lg:grid-cols-[0.95fr_1.05fr] lg:p-8 ${index % 2 === 1 ? 'lg:[&>*:first-child]:order-2' : ''}`}>
              <img src={service.image} alt={service.title} className="h-[280px] w-full rounded-[1.5rem] object-cover sm:h-[320px]" />
              <div>
                <div className="mb-4 flex items-center gap-2 text-amber-700">
                  <Factory size={18} />
                  <h3 className="text-2xl font-semibold text-slate-900">{service.title}</h3>
                </div>
                <p className="leading-8 text-slate-600">{service.text}</p>
                <ul className="mt-5 space-y-2 text-slate-600">
                  {service.bulletPoints.map((point) => <li key={point} className="flex items-center gap-2"><CheckCircle2 size={16} className="text-amber-700" />{point}</li>)}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderCertifications = () => (
    <div className="bg-[#f8f5ee] py-20 sm:py-24">
      <div className={sectionClasses}>
        <SectionHeading title="Quality Assurance & Certifications" eyebrow="Trusted compliance" />
        <div className="mb-10 max-w-3xl">
          <h3 className="text-2xl font-semibold text-slate-900 sm:text-3xl">Company registrations and credentials</h3>
          <p className="mt-3 leading-8 text-slate-600">Explore the registrations and compliance documents that support our work across food supply, domestic business, and international trade.</p>
        </div>
        <div className="grid gap-6 sm:grid-cols-2">
          {certifications.map((cert) => {
            const CardWrapper = cert.file ? 'a' : 'div';

            return (
            <CardWrapper
              key={cert.title}
              {...(cert.file ? { href: cert.file, target: '_blank', rel: 'noreferrer', 'aria-label': `Open ${cert.title}` } : {})}
              className="group rounded-[2rem] border border-slate-200 bg-white p-7 shadow-sm transition hover:-translate-y-1 hover:border-amber-500 hover:shadow-lg"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-amber-100 text-amber-700">
                  {cert.image ? <img src={cert.image} alt="" className="h-full w-full object-contain" /> : <FileText size={28} />}
                </div>
                {cert.file && <span className="rounded-full bg-[#f8f5ee] px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-amber-700">Open document</span>}
              </div>
              <p className="mt-7 text-xs font-semibold uppercase tracking-[0.2em] text-amber-700">{cert.category}</p>
              <h3 className="mt-2 text-xl font-semibold text-slate-900">{cert.title}</h3>
              <p className="mt-3 leading-7 text-slate-600">{cert.desc}</p>
              {cert.file && <div className="mt-6 flex items-center gap-2 text-sm font-semibold text-slate-900 transition group-hover:text-amber-700">
                View certificate <ArrowRight size={16} />
              </div>}
            </CardWrapper>
            );
          })}
        </div>
        <div className="mt-10 rounded-[2rem] border border-slate-200 bg-white p-8 text-center shadow-sm">
          <p className="text-lg leading-8 text-slate-600">Our commitment to excellence is backed by these prestigious certifications, giving our global partners confidence and peace of mind.</p>
        </div>
      </div>
    </div>
  );

  const renderGallery = () => {
    const procurementSteps = [
      { title: 'Direct Farmer Sourcing', text: 'We procure peanuts directly from farmers and established farming communities, helping us maintain better control over quality and freshness.' },
      { title: 'Quality Selection', text: 'Every lot is carefully evaluated for size, moisture, appearance, maturity, and overall quality before procurement.' },
      { title: 'Reliable Procurement Network', text: 'Our strong relationships with farmers and local suppliers help us ensure a consistent supply throughout the season.' },
      { title: 'Traceability & Transparency', text: 'We maintain proper procurement records and follow systematic quality checks from farm collection to processing.' }
    ];

    const processSteps = [
      { title: 'Cleaning', text: 'Freshly procured peanuts undergo thorough cleaning to remove dust, dirt, stones, plant residues, and other unwanted materials.' },
      { title: 'Destoning', text: 'Advanced destoning equipment separates stones and heavy foreign materials from the peanuts, ensuring a clean and safe product.' },
      { title: 'Sorting', text: 'Peanuts are carefully sorted to remove damaged, discoloured, immature, and defective kernels, maintaining uniform quality throughout the batch.' },
      { title: 'Grading', text: 'Peanuts are graded according to size, quality, and customer specifications to meet different market requirements.' },
      { title: 'Quality Inspection', text: 'Each batch is checked at different stages of processing to maintain hygiene, quality, and export standards before packaging.' },
      { title: 'Packaging', text: 'Processed peanuts are packed securely in suitable food-grade packaging according to customer and market requirements.' }
    ];

    return (
      <div className="bg-[#f8f5ee] py-20 sm:py-24">
        <div className={sectionClasses}>
            <section className="mb-20 border-b border-slate-200 pb-20">
              <SectionHeading title="Procurement Process - Direct from Farmers" eyebrow="Responsible sourcing" />
              <div className="mx-auto mb-12 max-w-4xl text-center">
                <p className="text-lg leading-8 text-slate-600">
                  At Hanuman Global Exports and Imports, our procurement process begins directly at the farm. We work closely with farmers and trusted agricultural networks to source high-quality peanuts with consistent standards.
                </p>
              </div>
              <div className="grid gap-6 md:grid-cols-2">
                {procurementSteps.map((step, index) => (
                  <article key={step.title} className="rounded-[1.75rem] border border-slate-200 bg-white p-7 shadow-sm">
                    <div className="flex items-center gap-4">
                      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-100 text-lg font-semibold text-amber-700">{String(index + 1).padStart(2, '0')}</span>
                      <h3 className="text-xl font-semibold text-slate-900">{step.title}</h3>
                    </div>
                    <p className="mt-5 leading-7 text-slate-600">{step.text}</p>
                  </article>
                ))}
              </div>
              <div className="mx-auto mt-10 max-w-4xl rounded-[2rem] bg-white p-8 text-center shadow-sm ring-1 ring-slate-200">
                <h3 className="text-2xl font-semibold text-slate-900">From Farm to Global</h3>
                <p className="mt-4 leading-8 text-slate-600">Our goal is to connect quality agricultural produce from Indian farms with buyers across global markets.</p>
              </div>
            </section>

            <section>
          <SectionHeading title="Our Processing Unit" eyebrow="From farm to global" />
          <div className="mx-auto mb-12 max-w-4xl text-center">
            <p className="text-lg leading-8 text-slate-600">
              At Hanuman Global Exports and Imports, our processing unit follows a systematic process to ensure that every batch of peanuts meets high standards of cleanliness, quality, and consistency before reaching our customers.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {processSteps.map((step, index) => (
              <article key={step.title} className="rounded-[1.75rem] border border-slate-200 bg-white p-7 shadow-sm transition hover:-translate-y-1 hover:shadow-md">
                <div className="flex items-center gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-100 text-lg font-semibold text-amber-700">{String(index + 1).padStart(2, '0')}</span>
                  <h3 className="text-xl font-semibold text-slate-900">{step.title}</h3>
                </div>
                <p className="mt-5 leading-7 text-slate-600">{step.text}</p>
              </article>
            ))}
          </div>

          <div className="mt-12 rounded-[2rem] bg-slate-900 px-7 py-10 text-center text-white sm:px-12">
            <h3 className="text-2xl font-semibold sm:text-3xl">From Farm to Global</h3>
            <p className="mx-auto mt-4 max-w-3xl leading-8 text-slate-300">
              From careful procurement to professional processing and secure packaging, we focus on delivering quality peanuts ready for global markets.
            </p>
          </div>

          <div className="mt-16">
            <h3 className="mb-7 text-center text-2xl font-semibold text-slate-900">Inside Our Operations</h3>
            <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
              {[millImg1, millImg2, millImg3, millImg4].map((image, index) => (
                <div key={index} className="overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white p-2 shadow-sm">
                  <img src={image} alt={`Mill operations ${index + 1}`} className="h-72 w-full rounded-[1.25rem] object-cover" />
                </div>
              ))}
            </div>
          </div>
          </section>
        </div>
      </div>
    );
  };

  const renderContact = () => (
    <div className="bg-[#f8f5ee] py-20 sm:py-24">
      <div className={sectionClasses}>
        <SectionHeading title="Let’s Connect" eyebrow="Get in touch" />
        <div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr]">
          <div className="space-y-5 rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm sm:p-10">
            <div className="flex gap-4 rounded-2xl bg-[#faf7f1] p-5">
              <img src={contactlocation} alt="Location" className="h-12 w-12 rounded-full object-cover" />
              <div>
                <h3 className="font-semibold text-slate-900">Our Office</h3>
                <p className="mt-2 leading-7 text-slate-600">44.44/37-5-4, Utukur, Kadapa, AP 516003, Andhra Pradesh, India.</p>
              </div>
            </div>
            <div className="flex gap-4 rounded-2xl bg-[#faf7f1] p-5">
              <img src={contactmail} alt="Email" className="h-12 w-12 rounded-full object-cover" />
              <div>
                <h3 className="font-semibold text-slate-900">Email Us</h3>
                <a href="mailto:hanumanglobalexportsimports@gmail.com" className="mt-2 block leading-7 text-slate-600 hover:text-amber-700">hanumanglobalexportsimports@gmail.com</a>
              </div>
            </div>
            <div className="flex gap-4 rounded-2xl bg-[#faf7f1] p-5">
              <img src={contactphone} alt="Phone" className="h-12 w-12 rounded-full object-cover" />
              <div>
                <h3 className="font-semibold text-slate-900">Call Us</h3>
                <a href="tel:+919381112460" className="mt-2 block leading-7 text-slate-600 hover:text-amber-700">+91 93811 12460</a>
              </div>
            </div>
          </div>

          <div className="rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm sm:p-10">
            <form onSubmit={(event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const name = formData.get('name');
              const email = formData.get('email');
              const message = formData.get('message');
              const recipient = '919381112460';
              const text = `*New Inquiry*\n*Name:* ${name}\n*Email:* ${email}\n*Message:* ${message}`;
              const encodedText = encodeURIComponent(text);
              window.open(`https://wa.me/${recipient}?text=${encodedText}`, '_blank');
            }} className="space-y-5">
              <div>
                <label className="mb-2 block text-sm font-semibold text-slate-700">Name</label>
                <input name="name" required className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-100" placeholder="Your Name" />
              </div>
              <div>
                <label className="mb-2 block text-sm font-semibold text-slate-700">Email</label>
                <input type="email" name="email" required className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-100" placeholder="Your Email" />
              </div>
              <div>
                <label className="mb-2 block text-sm font-semibold text-slate-700">Message</label>
                <textarea name="message" rows="5" required className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-100" placeholder="Your Message" />
              </div>
              <button type="submit" className="w-full rounded-2xl bg-slate-950 px-6 py-3 font-semibold text-white transition hover:bg-slate-800">
                Send to WhatsApp
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'about': return renderAbout();
      case 'products': return renderProducts();
      case 'services': return renderServices();
      case 'certifications': return renderCertifications();
      case 'gallery': return renderGallery();
      case 'contact': return renderContact();
      default: return renderHome();
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f5ee] text-slate-800">
      <Navbar activeTab={activeTab} navigateTo={navigateTo} logoImg={logoImg} isMobile={isMobile} />
      <main className="pt-24 md:pt-28">{renderActiveTab()}</main>
      <Footer contactmail={contactmail} contactphone={contactphone} contactlocation={contactlocation} mailIcon={mailIcon} phoneIcon={phoneIcon} locationIcon={locationIcon} />
    </div>
  );
};

export default HanumanModern;
